import { useEffect, useState } from "react";
// import { useNavigate } from "react-router-dom";
import { Pathname } from "../../../constants/pathnames/pathname";
import { Box, Grid } from "@mui/material";
import { styled } from "@mui/material";
import images from "../../../assets/images";
import DynamicInput from "../../../components/form-control/form-builder/form-builder-element/text";
import { useForm } from "react-hook-form";
import Typography from "../../../components/typography/typography";
import Button from "../../../components/button/button";
// import DynamicCheckBox from "../../../components/form-control/form-builder/form-builder-element/checkbox";
// import { Eye, EyeOff } from "../../../components/icons";
// import { LoginFormValues } from '@erpsquad/common/runtime';
// import { useAuth } from '@erpsquad/common/runtime';
import Toast from "../../../components/toast/toast";
import * as Yup from "yup";
import { yupResolver } from "@hookform/resolvers/yup";
import { useAuth } from '@erpsquad/common/runtime';
import { useNavigate } from "react-router-dom";
import { getApiConfig } from "@/utils";

export const ForgotPassword = () => {
   const { forgotPassword } = useAuth();
    const LoginContainer = styled(Grid)(() => ({
        height: "100vh",
    }));
    const navigate = useNavigate();
    interface IToast {
        message: string;
        type: "normal" | "alert";
    }
    const [toast, setToast] = useState<IToast | null>(null);

    const validationSchema = Yup.object({
      login: Yup.object({
        email: Yup.string()
          .required("Please enter email")
          .email("Provided email is invalid")
      }),
    });

    const { control, handleSubmit } = useForm<FormValeus>({
        resolver: yupResolver(validationSchema),
        mode: "all",
    });

    const LeftGrid = styled(Grid)(({ theme }) => ({
      [theme.breakpoints.down("sm")]: {
        display: "none",
      },
      backgroundImage: `url(${images.login.LoginLeftBg})`,
      backgroundRepeat: "no-repeat",
      backgroundSize: "cover",
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      [theme.breakpoints.down("lg")]: {
        "& img": {
          width: 350,
          height: 350,
        },
      },
      [theme.breakpoints.down("md")]: {
        "& img": {
          width: 300,
          height: 300,
        },
      },
    }));

    const RightGrid = styled(Grid)(() => ({
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      padding: "1rem",
    }));
    
    const FlexBox = styled(Box)(() => ({
      display: "flex",
      flexDirection: "column",
    }));

    const onSubmit = async (values: FormValeus) => {
      await forgotPassword(values.login, (type, message) => {
        if (type) {
          setToast({ message: message, type: "normal" });
          setTimeout(() => {
            navigate(Pathname.LOGIN);
          }, 1500);
        } else {
          setToast({ message: message, type: "alert" });
        }
      });
        return values;
    };

    const handleBackToLogin = () => {
      navigate(Pathname.LOGIN);
    }

    useEffect(() => {});

    const appLogo = getApiConfig().appLogo || images.erp_logo

    return (
        <Box>
              <LoginContainer container>
                <LeftGrid item sm={6}>
                  <img src={images.login.LoginLeftSiteImage} />
                </LeftGrid>
                <RightGrid item sm={6} xs={12}>
                  <FlexBox
                    display="flex"
                    flexDirection="column"
                    gap={4}
                    sx={(theme) => ({
                      minWidth: 400,
                      [theme.breakpoints.down("md")]: {
                        minWidth: 300,
                      },
                      [theme.breakpoints.down("sm")]: {
                        minWidth: 300,
                      },
                    })}
                  >
                    <Box textAlign="center">
                      <img src={appLogo} width={160} height={55}/>
                    </Box>
                    <form onSubmit={handleSubmit(onSubmit)}>
                      <FlexBox gap={4}>
                        <FlexBox gap={3}>
                          <Box>
                            <Typography
                              align="center"
                              type="h1"
                              weight="medium"
                              color="theme.secondary.1000"
                            >
                              Forgot Password
                            </Typography>
                            <Typography
                              align="center"
                              type="h5"
                              weight="normal"
                              color="theme.secondary81000"
                            >
                              Enter your email to reset password
                            </Typography>
                          </Box>
                          <FlexBox gap={2}>
                            <Box>
                              <DynamicInput
                                formControl={control}
                                label="Email"
                                name="email"
                                placeholder="Enter email"
                                fieldArrayName="login"
                              />
                            </Box>
                          </FlexBox>
                        </FlexBox>
                        <FlexBox gap={2}>
                          <Button type="submit" size="large" variant="contained">
                            Reset Password
                          </Button>
                          <Button
                              variant="text"
                              sx={(theme) => ({
                                color: `${theme.palette.theme?.primary["700"]} !important`,
                              })}
                              onClick = {handleBackToLogin}
                            >
                              Back to login
                            </Button>
                        </FlexBox>
                      </FlexBox>
                    </form>
                  </FlexBox>
                </RightGrid>
              </LoginContainer>
              <Toast
                open={Boolean(toast)}
                message={toast?.message}
                type={toast?.type}
                handleClose={() => setToast(null)}
                anchorOrigin={{ horizontal: "right", vertical: "bottom" }}
                autoHideDuration={3000}
              />
            </Box>
    )
}